import { Component, OnInit } from "@angular/core";
import { ComponentInterface } from "../../models/component.interface";
import { ComponentConfig } from "../../models/component-config.interface";
import { DashboardService } from "../../../../../services/dashboard.service";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-image",
  templateUrl: "./image.component.html",
  styleUrls: ["image.component.css"],
})
export class ImageComponent implements ComponentInterface, OnInit {
  config: ComponentConfig;

  imageSrc: any;
  title: string = "";
  subtitle: string;
  isLoading = true;

  constructor(
    private _dashboardService: DashboardService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this._dashboardService.getBloccoSlider(this.config.token).subscribe(
      (blocco) => {
        this.title = blocco.titolo;
        this.subtitle = blocco.sottotitolo;
        this._dashboardService.downloadFile(blocco.imageSrc).subscribe(
          (file) => {
            // this.createAImageFromBlob(file);
            const basePath = this._dashboardService.getBasePath();
            const downloadPath = "bloccofile/Download/";
            const imageSrc = `${basePath}${downloadPath}${blocco.imageSrc}`;
            this.imageSrc = imageSrc;
            this.isLoading = false;
          },
          (err) => {
            this.isLoading = false;
          }
        );
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  // createAImageFromBlob(image: Blob) {
  //   let reader = new FileReader();
  //   reader.addEventListener("load", () => {
  //     this.imageSrc = this.sanitizer.bypassSecurityTrustResourceUrl(reader.result);
  //   }, false);

  //   if (image) {
  //     reader.readAsDataURL(image);
  //   }
  //   this.isLoading = false;
  // }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/image/image.component.ts